(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["animia-cart-cpf-field"] && !Shopify.designMode) return;
  try {
    const requiredFieldGroups = document.querySelectorAll('[data-animia-cart-required-fields]');

  requiredFieldGroups.forEach((group) => {
    const inputs = group.querySelectorAll('[data-animia-cart-field]');

    inputs.forEach((input) => {
      const kind = input.getAttribute('data-animia-cart-field');
      const error = group.querySelector(`[data-animia-cart-error="${kind}"]`);

      const validate = () => {
        const digits = input.value.replace(/\D/g, '');
        let isValid = false;

        if (kind === 'cpf') {
          isValid = digits.length === 11 || digits.length === 14;
        }

        if (kind === 'phone') {
          isValid = digits.length === 10 || digits.length === 11 || (digits.startsWith('55') && (digits.length === 12 || digits.length === 13));
        }

        input.setCustomValidity(isValid ? '' : error?.textContent?.trim() || '');
        input.setAttribute('aria-invalid', isValid ? 'false' : 'true');

        if (error) {
          error.hidden = isValid || input.value.trim() === '';
        }
      };

      input.addEventListener('input', validate);
      input.addEventListener('blur', validate);
      validate();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
